<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-xs-12 metric-container">
                <button
                    class="btn btn-link btn-delete"
                    @click="$emit('delete')"
                    title="Hapus"
                >
                    <i class="fa fa-trash" />
                </button>
                <div class="col-xs-12">
                    <x-form-group
                        label="Nama Metrik"
                        :error="getError('label')"
                        :is-required="true"
                        :horizontal="false"
                    >
                        <input
                            type="text"
                            class="form-control"
                            v-model="fields.label"
                            required
                        />
                    </x-form-group>
                </div>
                <div class="col-xs-12">
                    <x-form-group
                        label="Tergabung Ke Group"
                        :error="getError('group_includes')"
                        :is-required="false"
                        :horizontal="false"
                    >
                        <x-input-groups v-model="fields.group_includes" />
                    </x-form-group>
                </div>
                <div class="col-xs-12">
                    <x-form-group
                        label="Tidak Tergabung Ke Group"
                        :error="getError('group_excludes')"
                        :is-required="false"
                        :horizontal="false"
                    >
                        <x-input-groups v-model="fields.group_excludes" />
                    </x-form-group>
                </div>
                <div class="col-xs-12">
                    <x-form-group
                        label="Tergabung Ke Kategori"
                        :error="getError('category_includes')"
                        :is-required="false"
                        :horizontal="false"
                    >
                        <x-input-group-categories
                            v-model="fields.category_includes"
                        />
                    </x-form-group>
                </div>
                <div class="col-xs-12">
                    <x-form-group
                        label="Tidak Tergabung Ke Kategori"
                        :error="getError('category_excludes')"
                        :is-required="false"
                        :horizontal="false"
                    >
                        <x-input-group-categories
                            v-model="fields.category_excludes"
                        />
                    </x-form-group>
                </div>
                <div class="col-xs-12">
                    <x-form-group
                        label="Status"
                        :error="getError('status')"
                        :is-required="false"
                        :horizontal="false"
                    >
                        <v-select
                            v-model="fields.status"
                            :options="availableStatus"
                            multiple
                        />
                        <x-help-default>
                            Bila kosong, secara default akan menghitung Jemaat
                            dengan status <code>Jemaat Aktif</code>,
                            <code>Sekolah Minggu</code>, dan <code>Youth</code>.
                        </x-help-default>
                    </x-form-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import XAddItemButton from "../../components/XAddItemButton.vue";
import XAjaxDropdown from "../../components/XAjaxDropdown.vue";
import XCheckboxWrapper from "../../components/XCheckboxWrapper.vue";
import XDeleteItemButton from "../../components/XDeleteItemButton.vue";
import XFilterBox from "../../components/XFilterBox.vue";
import XFormGroup from "../../components/XFormGroup.vue";
import XHelpDefault from "../../components/XHelpDefault.vue";
import XInputGroupCategories from "../../components/XInputGroupCategories.vue";
import XInputGroups from "../../components/XInputGroups.vue";
import XTable from "../../components/XTable.vue";
import { memberStatus } from "../../constants";
import FormErrorMixin from "../../mixins/FormErrorMixin";
import PropertySyncMixin from "../../mixins/PropertySyncMixin";

export default {
    components: {
        XFormGroup,
        XFilterBox,
        XCheckboxWrapper,
        XTable,
        XAddItemButton,
        XAjaxDropdown,
        XDeleteItemButton,
        XInputGroupCategories,
        XInputGroups,
        XHelpDefault,
    },
    computed: {
        availableStatus() {
            return Object.values(memberStatus);
        },
    },
    created() {
        this.fields = {
            ...this.fields,
            ...this.value,
        };
    },
    data() {
        return {
            fields: {
                id: new Date().getTime(),
                label: null,
                group_excludes: [],
                group_includes: [],
                category_excludes: [],
                category_includes: [],
            },
        };
    },
    mixins: [FormErrorMixin, PropertySyncMixin],
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Object,
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: null,
        },
        initialFields: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        value: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
    watch: {
        fields: {
            handler(newVal) {
                this.$emit("input", { ...newVal });
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.btn-delete {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 9999999;
}
.metric-container {
    position: relative;
    padding: 10px;
    border: 1px solid rgb(181, 181, 181);
    margin-bottom: 10px;
}
</style>
